import styled from "styled-components";

export const AuctionReservationWrapper = styled.div`
  .auctionTable {
    min-width: 2200px;
  }
  .date-range-container {
    border-radius: 10px;
  }
  .date-range-container > div:first-child input {
    border-radius: 10px 0 0px 10px;
  }
  .date-range-container > div:last-child input {
    border-radius: 0 10px 10px 0;
  }
  .date-range-container input {
    background: white !important;
    border: 1px solid #ced4da;
    width: 10rem;
  }
  .accept {
    color: #5d78ff;
    border: 1px solid #5d78ff;
    font-weight: 700;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    padding: 4px 22px;
    border-radius: 3px;
    word-break: normal;
  }

  .reject {
    padding: 4px 22px;
    color: #ff2828;
    font-weight: 700;
    border: 1px solid #ff2828 !important;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    border-radius: 3px;
    word-break: normal;
  }
  .access-btn {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .disabled {
    cursor: not-allowed;
    pointer-events: all !important;
    opacity: 50%;
  }
  .message-text {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    width: 150px;
  }
  .dropbtn {
    cursor: pointer;
  }
  .dropped {
    width: 100%;
    text-align: unset;
    margin-left: 10px;
  }
  .open {
    transform: rotate(-90deg);
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
  .close {
    transform: rotate(90deg);
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
  .minwidth-150 {
    min-width: 150px;
  }
  .maxwidth-110 {
    max-width: 110px;
  }
  .minwidth-220 {
    min-width: 220px;
  }
  .disputeAction {
    font-style: italic;
  }
  .accepted {
    color: rgb(0, 156, 0);
  }
  .rejected {
    color: rgb(248, 0, 0);
  }
  .attachmentsContainer{
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
`;
